import { theme } from '@frontend/theme';
import { Text, SkeletonLoader } from '@frontend/design-system';

type HeaderTextProps = {
  text: string;
  loading?: boolean;
};

export const HeaderText = ({ text, loading = false }: HeaderTextProps) => {
  if (loading) {
    return <SkeletonLoader height={16} width='80%' />;
  }

  if (text) {
    return (
      <Text size='large' css={{ color: theme.colors.black }}>
        {text}
      </Text>
    );
  }
  return null;
};
